export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
} as const;

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';
